export default __webpack_public_path__ + "static/media/mke-zoo-amur-tiger.1ffe92e4.jpg";